import Vue from 'vue';
import VueRouter from 'vue-router';
import BasicLayout from '@/layout/BasicLayout.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/pay/success',
    name: 'PaySuccess',
    component: () => import('@/views/pay/PaySuccess.vue'),
    meta: { title: '支付成功' }
  },
  {
    path: '/mobile/meter-reading',
    name: 'MobileMeterReading',
    component: () => import('@/views/mobile/MobileMeterReading.vue'),
    meta: { title: '移动抄表' }
  },
  {
    path: '/mobile/equipment',
    name: 'MobileEquipmentDetail',
    component: () => import('@/views/mobile/MobileEquipmentDetail.vue'),
    meta: { title: '设备档案' }
  },
  {
    path: '/mobile/inspect-check',
    name: 'MobileInspectCheck',
    component: () => import('@/views/mobile/MobileInspectCheck.vue'),
    meta: { title: '巡检扫码打卡' }
  },
  {
    path: '/mobile/inspect-nfc',
    name: 'MobileInspectNfc',
    component: () => import('@/views/mobile/MobileInspectNfc.vue'),
    meta: { title: 'NFC巡检打卡' }
  },
  {
    path: '/mobile/vas-verify',
    name: 'MobileVasVerify',
    component: () => import('@/views/mobile/MobileVasVerify.vue'),
    meta: { title: '增值服务核销' }
  },
  {
    path: '/mobile/vas-shop',
    name: 'MobileVasShop',
    component: () => import('@/views/mobile/MobileVasShop.vue'),
    meta: { title: '增值服务下单' }
  },
  {
    path: '/mobile/vas-orders',
    name: 'MobileVasOrders',
    component: () => import('@/views/mobile/MobileVasOrders.vue'),
    meta: { title: '增值服务订单' }
  },
  {
    path: '/mobile/club-book',
    name: 'MobileClubBook',
    component: () => import('@/views/mobile/MobileClubBook.vue'),
    meta: { title: '会所场地预约' }
  },
  {
    path: '/mobile/staff-home',
    name: 'MobileStaffHome',
    component: () => import('@/views/mobile/MobileStaffHome.vue'),
    meta: { title: '员工工作台' }
  },
  {
    path: '/',
    component: BasicLayout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/HomePage.vue'),
        meta: { title: '工作台' }
      },
      {
        path: 'home/dashboard-config',
        name: 'DashboardConfig',
        component: () => import('@/views/home/DashboardConfig.vue'),
        meta: { title: '灵活看板' }
      },
      {
        path: 'home/hotzone',
        name: 'HotzoneMap',
        component: () => import('@/views/home/HotzoneMap.vue'),
        meta: { title: '热区信息' }
      },
      {
        path: 'archives/area',
        name: 'AreaList',
        component: () => import('@/views/area/AreaList.vue'),
        meta: { title: '项目管理' }
      },
      {
        path: 'archives/grid',
        name: 'GridManage',
        component: () => import('@/views/grid/GridManage.vue'),
        meta: { title: '网格管理' }
      },
      {
        path: 'archives/room',
        name: 'RoomList',
        component: () => import('@/views/room/RoomList.vue'),
        meta: { title: '房产信息' }
      },
      {
        path: 'archives/customer',
        name: 'CustomerList',
        component: () => import('@/views/customer/CustomerList.vue'),
        meta: { title: '客户档案' }
      },
      {
        path: 'archives/meter',
        name: 'MeterList',
        component: () => import('@/views/meter/MeterList.vue'),
        meta: { title: '仪表管理' }
      },
      {
        path: 'archives/recycle',
        name: 'RoomRecycle',
        component: () => import('@/views/room/RoomRecycle.vue'),
        meta: { title: '房间回收站' }
      },
      // ---------- 物业收费 ----------
      {
        path: 'charge/fee-item',
        name: 'FeeItemList',
        component: () => import('@/views/charge/FeeItemList.vue'),
        meta: { title: '费用定义' }
      },
      {
        path: 'charge/dashboard',
        name: 'ChargeDashboard',
        component: () => import('@/views/charge/ChargeCenter.vue'),
        meta: { title: '收费看板', permKey: 'charge/center' }
      },
      // 保留旧地址，避免已收藏的“收费中心”链接失效。
      {
        path: 'charge/center',
        redirect: '/charge/dashboard',
        meta: { title: '收费看板', permKey: 'charge/center' }
      },
      {
        path: 'charge/fee-set',
        name: 'FeeSetList',
        component: () => import('@/views/charge/FeeSetList.vue'),
        meta: { title: '费用分配' }
      },
      {
        path: 'charge/meter-reading',
        name: 'MeterReadingList',
        component: () => import('@/views/charge/MeterReadingList.vue'),
        meta: { title: '抄表' }
      },
      {
        path: 'charge/receivable',
        name: 'ReceivableList',
        component: () => import('@/views/charge/ReceivableList.vue'),
        meta: { title: '生成应收', permKey: 'charge/receivable' }
      },
      {
        path: 'charge/cashier',
        name: 'Cashier',
        component: () => import('@/views/charge/Cashier.vue'),
        meta: { title: '收银台' }
      },
      {
        path: 'charge/receivables',
        redirect: '/charge/receivable',
        meta: { title: '生成应收', permKey: 'charge/receivable' }
      },
      {
        path: 'charge/receivables/temp',
        name: 'TemporaryReceivable',
        component: () => import('@/views/charge/TemporaryReceivable.vue'),
        meta: { title: '生成应收-临时', permKey: 'charge/receivable' }
      },
      {
        path: 'charge/payments',
        name: 'PaymentList',
        component: () => import('@/views/charge/ChargeFinancial.vue'),
        props: { mode: 'payments' },
        meta: { title: '收款记录', permKey: 'charge/cashier' }
      },
      {
        path: 'charge/prepayments',
        name: 'PrepayCenter',
        component: () => import('@/views/charge/PrepayCenter.vue'),
        meta: { title: '预收款', permKey: 'charge/cashier' }
      },
      {
        path: 'charge/prepayments/offset',
        name: 'PrepayOffset',
        component: () => import('@/views/charge/PrepayCenter.vue'),
        props: { offsetMode: true },
        meta: { title: '批量冲预收款', permKey: 'charge/cashier' }
      },
      {
        path: 'charge/discounts',
        name: 'DiscountList',
        component: () => import('@/views/charge/ChargeFinancial.vue'),
        props: { mode: 'discounts' },
        meta: { title: '折扣管理', permKey: 'charge/receivable' }
      },
      {
        path: 'charge/receipts',
        name: 'ReceiptList',
        component: () => import('@/views/charge/ChargeFinancial.vue'),
        props: { mode: 'receipts' },
        meta: { title: '票据管理', permKey: 'charge/cashier' }
      },
      {
        path: 'charge/invoices',
        name: 'InvoiceList',
        component: () => import('@/views/charge/InvoiceExchange.vue'),
        meta: { title: '换发票', permKey: 'charge/cashier' }
      },
      {
        path: 'charge/refunds',
        name: 'RefundList',
        component: () => import('@/views/charge/RefundBusiness.vue'),
        meta: { title: '退费业务', permKey: 'charge/cashier' }
      },
      {
        path: 'charge/reconciliation',
        name: 'BankReconciliation',
        component: () => import('@/views/charge/BankReconciliation.vue'),
        meta: { title: '银行对账', permKey: 'charge/cashier' }
      },
      {
        path: 'charge/payment-config',
        name: 'PaymentConfig',
        component: () => import('@/views/charge/PaymentConfig.vue'),
        props: { mode: 'config' },
        meta: { title: '支付配置', permKey: 'charge/cashier' }
      },
      // ---------- 数据报表 ----------
      {
        path: 'report/center',
        name: 'ReportCenter',
        component: () => import('@/views/report/ReportCenter.vue'),
        meta: { title: '报表中心' }
      },
      // ---------- 社区运营 / 物业活动 / 公众号 ----------
      {
        path: 'community/main',
        name: 'CommunityMain',
        component: () => import('@/views/community/CommunityMain.vue'),
        meta: { title: '社区运营', permKey: 'community/main' }
      },
      {
        path: 'mp/center',
        redirect: '/mp/verify'
      },
      {
        path: 'mp/verify',
        name: 'MpVerify',
        component: () => import('@/views/community/OfficialAccountCenter.vue'),
        meta: { title: '用户审核', permKey: 'mp/verify', mpModule: 'verify' }
      },
      {
        path: 'mp/payment',
        name: 'MpPayment',
        component: () => import('@/views/community/OfficialAccountCenter.vue'),
        meta: { title: '交费明细', permKey: 'mp/payment', mpModule: 'payment' }
      },
      {
        path: 'mp/posts',
        name: 'MpPosts',
        component: () => import('@/views/community/OfficialAccountCenter.vue'),
        meta: { title: '说说管理', permKey: 'mp/posts', mpModule: 'posts' }
      },
      {
        path: 'mp/rooms',
        name: 'MpRooms',
        component: () => import('@/views/community/OfficialAccountCenter.vue'),
        meta: { title: '房间管理', permKey: 'mp/rooms', mpModule: 'rooms' }
      },
      {
        path: 'mp/buildings',
        name: 'BuildingManage',
        component: () => import('@/views/community/BuildingManage.vue'),
        meta: { title: '楼盘管理', permKey: 'mp/buildings' }
      },
      {
        path: 'mp/push',
        name: 'MpPush',
        component: () => import('@/views/community/OfficialAccountCenter.vue'),
        meta: { title: '消息推送', permKey: 'mp/push', mpModule: 'push' }
      },
      {
        path: 'mp/arrears',
        name: 'MpArrears',
        component: () => import('@/views/community/OfficialAccountCenter.vue'),
        meta: { title: '欠费通知', permKey: 'mp/arrears', mpModule: 'arrears' }
      },
      {
        path: 'mp/notice',
        name: 'MpNotice',
        component: () => import('@/views/community/OfficialAccountCenter.vue'),
        meta: { title: '业主消息', permKey: 'mp/notice', mpModule: 'notice' }
      },
      {
        path: 'mp/info',
        name: 'MpInfo',
        component: () => import('@/views/community/OfficialAccountCenter.vue'),
        meta: { title: '公众号信息', permKey: 'mp/info', mpModule: 'info' }
      },
      {
        path: 'mp/deadline',
        name: 'MpDeadline',
        component: () => import('@/views/community/OfficialAccountCenter.vue'),
        meta: { title: '截止日期设置', permKey: 'mp/deadline', mpModule: 'deadline' }
      },
      {
        path: 'mp/owner-audit',
        name: 'MpOwnerAudit',
        component: () => import('@/views/community/OfficialAccountCenter.vue'),
        meta: { title: '业主审核', permKey: 'mp/owner-audit', mpModule: 'ownerAudit' }
      },
      {
        path: 'community/activity',
        name: 'ActivityManage',
        component: () => import('@/views/community/ActivityManage.vue'),
        meta: { title: '活动管理', permKey: 'community/activity' }
      },
      {
        path: 'community/voucher',
        name: 'VoucherManage',
        component: () => import('@/views/community/VoucherManage.vue'),
        meta: { title: '电子凭证活动', permKey: 'community/voucher' }
      },
      {
        path: 'community/gift-redeem',
        name: 'GiftRedeem',
        component: () => import('@/views/community/GiftRedeem.vue'),
        meta: { title: '礼品核销', permKey: 'community/gift-redeem' }
      },
      {
        path: 'owner-app/menu',
        name: 'OwnerAppMenu',
        component: () => import('@/views/community/OwnerAppMenu.vue'),
        meta: { title: '菜单设置', permKey: 'owner-app/menu' }
      },
      {
        path: 'community/activity-stats',
        name: 'ActivityStats',
        component: () => import('@/views/community/ActivityStats.vue'),
        meta: { title: '活动统计', permKey: 'community/activity-stats' }
      },
      {
        path: 'survey/manage',
        name: 'SurveyManage',
        component: () => import('@/views/community/SurveyManage.vue'),
        meta: { title: '问卷管理', permKey: 'survey/manage' }
      },
      {
        path: 'survey/vote',
        name: 'VoteManage',
        component: () => import('@/views/community/VoteManage.vue'),
        meta: { title: '投票系统', permKey: 'survey/vote' }
      },
      // ---------- 访客通行 ----------
      {
        path: 'visitor/list',
        name: 'VisitorList',
        component: () => import('@/views/visitor/VisitorList.vue'),
        meta: { title: '访客通行' }
      },
      // ---------- 物业公示/上报 ----------
      {
        path: 'disclosure/list',
        name: 'DisclosureList',
        component: () => import('@/views/disclosure/DisclosureList.vue'),
        meta: { title: '物业公示' }
      },
      {
        path: 'disclosure/feed',
        name: 'FeedList',
        component: () => import('@/views/disclosure/FeedList.vue'),
        meta: { title: '信息上报' }
      },
      // ---------- 新版OA / 表单管理 ----------
      {
        path: 'oa/main',
        redirect: '/oa/start'
      },
      {
        path: 'oa/start',
        name: 'OaStart',
        component: () => import('@/views/oa/OaStart.vue'),
        meta: { title: '发起流程', permKey: 'oa/start' }
      },
      {
        path: 'oa/todo',
        name: 'OaTodo',
        component: () => import('@/views/oa/OaTodo.vue'),
        meta: { title: '待办任务', permKey: 'oa/todo' }
      },
      {
        path: 'oa/process',
        name: 'OaProcess',
        component: () => import('@/views/oa/OaProcess.vue'),
        meta: { title: '流程管理', permKey: 'oa/process' }
      },
      {
        path: 'oa/template',
        name: 'OaTemplate',
        component: () => import('@/views/oa/OaTemplate.vue'),
        meta: { title: '表单模板', permKey: 'oa/template' }
      },
      {
        path: 'oa/type',
        name: 'OaType',
        component: () => import('@/views/oa/OaType.vue'),
        meta: { title: '表单类型', permKey: 'oa/type' }
      },
      {
        path: 'oa/maintain',
        name: 'OaMaintain',
        component: () => import('@/views/oa/OaMaintain.vue'),
        meta: { title: '表单维护', permKey: 'oa/maintain' }
      },
      {
        path: 'daily/list',
        name: 'DailyList',
        component: () => import('@/views/daily/DailyList.vue'),
        meta: { title: '日报列表', permKey: 'daily/list' }
      },
      // ---------- 短信/代扣 ----------
      {
        path: 'sms/main',
        name: 'SmsMain',
        component: () => import('@/views/sms/SmsMain.vue'),
        meta: { title: '短信设置' }
      },
      // ---------- 系统管理 ----------
      {
        path: 'system/user',
        name: 'UserManage',
        component: () => import('@/views/system/UserManage.vue'),
        meta: { title: '人员管理' }
      },
      {
        path: 'system/role',
        name: 'RoleList',
        component: () => import('@/views/system/RoleList.vue'),
        meta: { title: '角色管理' }
      },
      {
        path: 'system/dept',
        name: 'DeptManage',
        component: () => import('@/views/system/DeptManage.vue'),
        meta: { title: '部门管理' }
      },
      {
        path: 'system/post',
        name: 'PostList',
        component: () => import('@/views/system/PostList.vue'),
        meta: { title: '岗位管理' }
      },
      {
        path: 'system/notice',
        name: 'NoticeList',
        component: () => import('@/views/system/NoticeList.vue'),
        meta: { title: '公告管理' }
      },
      {
        path: 'system/menu',
        name: 'MenuManage',
        component: () => import('@/views/system/MenuManage.vue'),
        meta: { title: '菜单管理' }
      },
      {
        path: 'system/log',
        name: 'LogViewer',
        component: () => import('@/views/system/LogViewer.vue'),
        meta: { title: '日志查看' }
      },
      // ---------- 物业服务 ----------
      {
        path: 'service/accept',
        name: 'WorkOrderAccept',
        component: () => import('@/views/workorder/WorkOrderAccept.vue'),
        meta: { title: '业务受理', permKey: 'service/accept' }
      },
      {
        path: 'service/todo',
        name: 'WorkOrderTodo',
        component: () => import('@/views/workorder/WorkOrderTodo.vue'),
        meta: { title: '报事待办工单', permKey: 'service/todo' }
      },
      {
        path: 'service/query',
        name: 'WorkOrderQuery',
        component: () => import('@/views/workorder/WorkOrderQuery.vue'),
        meta: { title: '工单查询', permKey: 'service/query' }
      },
      {
        path: 'service/report',
        name: 'WorkOrderReport',
        component: () => import('@/views/workorder/WorkOrderReport.vue'),
        meta: { title: '工单工时报表', permKey: 'service/report' }
      },
      {
        path: 'service/grab',
        name: 'WorkOrderGrabConfig',
        component: () => import('@/views/workorder/WorkOrderGrabConfig.vue'),
        meta: { title: '抢单配置', permKey: 'service/grab' }
      },
      {
        path: 'service/closed',
        name: 'WorkOrderClosed',
        component: () => import('@/views/workorder/WorkOrderClosed.vue'),
        meta: { title: '工单完结明细', permKey: 'service/closed' }
      },
      {
        path: 'service/settings',
        name: 'WorkOrderSettings',
        component: () => import('@/views/workorder/WorkOrderSettings.vue'),
        meta: { title: '常用设置', permKey: 'service/settings' }
      },
      {
        path: 'service/push',
        name: 'WorkOrderPushConfig',
        component: () => import('@/views/workorder/WorkOrderPushConfig.vue'),
        meta: { title: '工单推送设置', permKey: 'service/push' }
      },
      {
        path: 'service/category',
        name: 'WorkOrderCategory',
        component: () => import('@/views/workorder/WorkOrderCategory.vue'),
        meta: { title: '报事类目设置', permKey: 'service/category' }
      },
      {
        path: 'service/work-order',
        name: 'WorkOrderList',
        component: () => import('@/views/workorder/WorkOrderList.vue'),
        meta: { title: '工单管理', permKey: 'service/work-order' }
      },
      {
        path: 'service/board',
        name: 'WorkOrderBoard',
        component: () => import('@/views/workorder/WorkOrderBoard.vue'),
        meta: { title: '工单看板', permKey: 'service/board' }
      },
      {
        path: 'service/center',
        name: 'WorkOrderCenter',
        component: () => import('@/views/workorder/WorkOrderCenter.vue'),
        meta: { title: '工单中心', permKey: 'service/center' }
      },
      // ---------- 设备管理 ----------
      {
        path: 'equipment/list',
        name: 'EquipmentList',
        component: () => import('@/views/equipment/EquipmentList.vue'),
        meta: { title: '设备档案', permKey: 'equipment/list' }
      },
      {
        path: 'equipment/work-content',
        name: 'EquipmentWorkContent',
        component: () => import('@/views/equipment/EquipmentWorkContent.vue'),
        meta: { title: '工作内容', permKey: 'equipment/work-content' }
      },
      {
        path: 'equipment/repair',
        name: 'EquipmentRepair',
        component: () => import('@/views/equipment/EquipmentRepair.vue'),
        meta: { title: '设备报修', permKey: 'equipment/repair' }
      },
      // ---------- 设备保养 ----------
      {
        path: 'maint/group',
        name: 'MaintGroup',
        component: () => import('@/views/equipment/MaintGroup.vue'),
        meta: { title: '保养分组', permKey: 'maint/group' }
      },
      {
        path: 'maint/plan',
        name: 'MaintPlan',
        component: () => import('@/views/equipment/MaintPlan.vue'),
        meta: { title: '保养计划', permKey: 'maint/plan' }
      },
      {
        path: 'maint/task',
        name: 'MaintTask',
        component: () => import('@/views/equipment/MaintTask.vue'),
        meta: { title: '保养任务', permKey: 'maint/task' }
      },
      // ---------- 智能巡检 ----------
      {
        path: 'inspection/board',
        name: 'InspectionBoard',
        component: () => import('@/views/inspection/InspectionBoard.vue'),
        meta: { title: '巡检看板', permKey: 'inspection/board' }
      },
      {
        path: 'inspection/point',
        name: 'InspectionPoint',
        component: () => import('@/views/inspection/InspectionPoint.vue'),
        meta: { title: '巡检点位', permKey: 'inspection/point' }
      },
      {
        path: 'inspection/route',
        name: 'InspectionRoute',
        component: () => import('@/views/inspection/InspectionRoute.vue'),
        meta: { title: '巡检线路', permKey: 'inspection/route' }
      },
      {
        path: 'inspection/group',
        name: 'InspectionGroup',
        component: () => import('@/views/inspection/InspectionGroup.vue'),
        meta: { title: '巡检分组', permKey: 'inspection/group' }
      },
      {
        path: 'inspection/plan',
        name: 'InspectionPlan',
        component: () => import('@/views/inspection/InspectionPlan.vue'),
        meta: { title: '巡检计划', permKey: 'inspection/plan' }
      },
      {
        path: 'inspection/task',
        name: 'InspectionTask',
        component: () => import('@/views/inspection/InspectionTask.vue'),
        meta: { title: '巡检任务', permKey: 'inspection/task' }
      },
      {
        path: 'inspection/report',
        name: 'InspectionReport',
        component: () => import('@/views/inspection/InspectionReport.vue'),
        meta: { title: '巡检报表', permKey: 'inspection/report' }
      },
      {
        path: 'inspection/stats',
        name: 'InspectionStats',
        component: () => import('@/views/inspection/InspectionStats.vue'),
        meta: { title: '执行统计报表', permKey: 'inspection/stats' }
      },
      // ---------- 智能巡更 ----------
      {
        path: 'patrol/point',
        name: 'PatrolPoint',
        component: () => import('@/views/patrol/PatrolPoint.vue'),
        meta: { title: '巡更点位', permKey: 'patrol/point' }
      },
      {
        path: 'patrol/route',
        name: 'PatrolRoute',
        component: () => import('@/views/patrol/PatrolRoute.vue'),
        meta: { title: '巡更线路', permKey: 'patrol/route' }
      },
      {
        path: 'patrol/group',
        name: 'PatrolGroup',
        component: () => import('@/views/patrol/PatrolGroup.vue'),
        meta: { title: '巡更分组', permKey: 'patrol/group' }
      },
      {
        path: 'patrol/plan',
        name: 'PatrolPlan',
        component: () => import('@/views/patrol/PatrolPlan.vue'),
        meta: { title: '巡更计划', permKey: 'patrol/plan' }
      },
      {
        path: 'patrol/task',
        name: 'PatrolTask',
        component: () => import('@/views/patrol/PatrolTask.vue'),
        meta: { title: '巡更任务', permKey: 'patrol/task' }
      },
      // ---------- 租赁合同 ----------
      {
        path: 'lease/list',
        name: 'LeaseList',
        component: () => import('@/views/lease/LeaseList.vue'),
        meta: { title: '租赁合同列表' }
      },
      {
        path: 'lease/form',
        name: 'LeaseFormCreate',
        component: () => import('@/views/lease/LeaseForm.vue'),
        meta: { title: '租赁合同添加' }
      },
      {
        path: 'lease/form/:id',
        name: 'LeaseFormEdit',
        component: () => import('@/views/lease/LeaseForm.vue'),
        meta: { title: '编辑租赁合同' }
      },
      {
        path: 'lease/rent-map',
        name: 'LeaseRentMap',
        component: () => import('@/views/lease/LeaseRentMap.vue'),
        meta: { title: '租控图' }
      },
      {
        path: 'lease/hotzone',
        name: 'LeaseHotzone',
        component: () => import('@/views/lease/LeaseHotzone.vue'),
        meta: { title: '热区图' }
      },
      {
        path: 'lease/report',
        name: 'LeaseReport',
        component: () => import('@/views/lease/LeaseReport.vue'),
        meta: { title: '合同报表' }
      },
      {
        path: 'lease/changes',
        name: 'LeaseChange',
        component: () => import('@/views/lease/LeaseChange.vue'),
        meta: { title: '变更与记录' }
      },
      {
        path: 'lease/template',
        name: 'LeaseTemplate',
        component: () => import('@/views/lease/LeaseTemplate.vue'),
        meta: { title: '模板管理' }
      },
      // ---------- 采购管理 ----------
      {
        path: 'purchase/request',
        name: 'PurchaseRequest',
        component: () => import('@/views/purchase/PurchaseRequest.vue'),
        meta: { title: '采购申请' }
      },
      {
        path: 'purchase/plan',
        name: 'PurchasePlan',
        component: () => import('@/views/purchase/PurchasePlan.vue'),
        meta: { title: '采购计划' }
      },
      {
        path: 'purchase/order',
        name: 'PurchaseOrder',
        component: () => import('@/views/purchase/PurchaseOrder.vue'),
        meta: { title: '采购订单' }
      },
      {
        path: 'purchase/ledger',
        name: 'PurchaseLedger',
        component: () => import('@/views/purchase/PurchaseLedger.vue'),
        meta: { title: '采购流水账' }
      },
      {
        path: 'purchase/payment',
        name: 'PurchasePayment',
        component: () => import('@/views/purchase/PurchasePayment.vue'),
        meta: { title: '付款单' }
      },
      // ---------- 仓库管理 ----------
      {
        path: 'warehouse/basic',
        name: 'WarehouseBasic',
        component: () => import('@/views/warehouse/WarehouseBasic.vue'),
        meta: { title: '基本信息' }
      },
      {
        path: 'warehouse/in',
        name: 'WarehouseIn',
        component: () => import('@/views/warehouse/StockDocPage.vue'),
        meta: { title: '入库操作', docType: 'IN' }
      },
      {
        path: 'warehouse/out',
        name: 'WarehouseOut',
        component: () => import('@/views/warehouse/StockDocPage.vue'),
        meta: { title: '出库操作', docType: 'OUT' }
      },
      {
        path: 'warehouse/transfer',
        name: 'WarehouseTransfer',
        component: () => import('@/views/warehouse/StockDocPage.vue'),
        meta: { title: '调拨操作', docType: 'TRANSFER' }
      },
      {
        path: 'warehouse/damage',
        name: 'WarehouseDamage',
        component: () => import('@/views/warehouse/StockDocPage.vue'),
        meta: { title: '报损操作', docType: 'DAMAGE' }
      },
      {
        path: 'warehouse/requisition',
        name: 'WarehouseRequisition',
        component: () => import('@/views/warehouse/StockDocPage.vue'),
        meta: { title: '领料审批', docType: 'REQUISITION' }
      },
      {
        path: 'warehouse/return-supplier',
        name: 'WarehouseReturnSupplier',
        component: () => import('@/views/warehouse/StockDocPage.vue'),
        meta: { title: '退货操作', docType: 'RETURN_SUPPLIER' }
      },
      {
        path: 'warehouse/return-stock',
        name: 'WarehouseReturnStock',
        component: () => import('@/views/warehouse/StockDocPage.vue'),
        meta: { title: '退库操作', docType: 'RETURN_STOCK' }
      },
      {
        path: 'warehouse/ticket',
        name: 'WarehouseTicket',
        component: () => import('@/views/warehouse/WarehouseTicket.vue'),
        meta: { title: '票据管理' }
      },
      {
        path: 'warehouse/stock',
        name: 'StockManage',
        component: () => import('@/views/warehouse/WarehouseStock.vue'),
        meta: { title: '库存管理' }
      },
      {
        path: 'warehouse/flow',
        name: 'WarehouseFlow',
        component: () => import('@/views/warehouse/WarehouseFlow.vue'),
        meta: { title: '出入库流水账' }
      },
      {
        path: 'warehouse/report',
        name: 'WarehouseReport',
        component: () => import('@/views/warehouse/WarehouseReport.vue'),
        meta: { title: '仓库汇总报表' }
      },
      {
        path: 'warehouse/split',
        name: 'WarehouseSplit',
        component: () => import('@/views/warehouse/StockDocPage.vue'),
        meta: { title: '项目分割单', docType: 'SPLIT' }
      },
      {
        path: 'warehouse/exchange',
        name: 'WarehouseExchange',
        component: () => import('@/views/warehouse/StockDocPage.vue'),
        meta: { title: '以旧换新登记', docType: 'EXCHANGE' }
      },
      // ---------- 招商CRM ----------
      { path: 'crm/main', redirect: '/crm/lead' },
      { path: 'crm/center', redirect: '/crm/property' },
      { path: 'sales/main', redirect: '/crm/performance' },
      {
        path: 'crm/property',
        name: 'CrmProperty',
        component: () => import('@/views/crm/CrmProperty.vue'),
        meta: { title: '房源列表', permKey: 'crm/property' }
      },
      {
        path: 'crm/team',
        name: 'CrmTeam',
        component: () => import('@/views/crm/CrmTeam.vue'),
        meta: { title: '招商团队', permKey: 'crm/team' }
      },
      {
        path: 'crm/agent',
        name: 'CrmAgent',
        component: () => import('@/views/crm/CrmAgent.vue'),
        meta: { title: '渠道代理', permKey: 'crm/agent' }
      },
      {
        path: 'crm/activity',
        name: 'CrmActivity',
        component: () => import('@/views/crm/CrmActivity.vue'),
        meta: { title: '市场活动', permKey: 'crm/activity' }
      },
      {
        path: 'crm/lead',
        name: 'CrmLead',
        component: () => import('@/views/crm/CrmLead.vue'),
        meta: { title: '线索管理', permKey: 'crm/lead' }
      },
      {
        path: 'crm/customer',
        name: 'CrmCustomer',
        component: () => import('@/views/crm/CrmCustomer.vue'),
        meta: { title: '客户管理', permKey: 'crm/customer' }
      },
      {
        path: 'crm/opportunity',
        name: 'CrmOpportunity',
        component: () => import('@/views/crm/CrmOpportunity.vue'),
        meta: { title: '商机管理', permKey: 'crm/opportunity' }
      },
      {
        path: 'crm/intention',
        name: 'CrmIntention',
        component: () => import('@/views/crm/CrmIntention.vue'),
        meta: { title: '意向管理', permKey: 'crm/intention' }
      },
      {
        path: 'crm/competitor',
        name: 'CrmCompetitor',
        component: () => import('@/views/crm/CrmCompetitor.vue'),
        meta: { title: '竞品市调', permKey: 'crm/competitor' }
      },
      {
        path: 'crm/visit',
        name: 'CrmVisit',
        component: () => import('@/views/crm/CrmVisit.vue'),
        meta: { title: '回访管理', permKey: 'crm/visit' }
      },
      {
        path: 'crm/pool-rule',
        name: 'CrmPoolRule',
        component: () => import('@/views/crm/CrmPoolRule.vue'),
        meta: { title: '公海池规则', permKey: 'crm/pool-rule' }
      },
      {
        path: 'crm/ext-field',
        name: 'CrmExtField',
        component: () => import('@/views/crm/CrmExtField.vue'),
        meta: { title: '扩展字段设置', permKey: 'crm/ext-field' }
      },
      {
        path: 'crm/rating',
        name: 'CrmRating',
        component: () => import('@/views/crm/CrmRating.vue'),
        meta: { title: '商户评级', permKey: 'crm/rating' }
      },
      {
        path: 'crm/performance',
        name: 'CrmPerformance',
        component: () => import('@/views/crm/CrmPerformance.vue'),
        meta: { title: '员工业绩管理', permKey: 'crm/performance' }
      },
      // ---------- 工作流 ----------
      {
        path: 'workflow/center',
        redirect: '/workflow/workspace'
      },
      {
        path: 'workflow/workspace',
        name: 'WorkflowWorkspace',
        component: () => import('@/views/workflow/WorkflowWorkspace.vue'),
        meta: { title: '工作空间', permKey: 'workflow/workspace' }
      },
      {
        path: 'workflow/initiated',
        name: 'WorkflowInitiated',
        component: () => import('@/views/workflow/WorkflowInitiated.vue'),
        meta: { title: '我发起的', permKey: 'workflow/initiated' }
      },
      {
        path: 'workflow/todo',
        name: 'WorkflowTodo',
        component: () => import('@/views/workflow/WorkflowTodo.vue'),
        meta: { title: '待我处理', permKey: 'workflow/todo' }
      },
      {
        path: 'workflow/handled',
        name: 'WorkflowHandled',
        component: () => import('@/views/workflow/WorkflowHandled.vue'),
        meta: { title: '已处理的', permKey: 'workflow/handled' }
      },
      {
        path: 'workflow/cc',
        name: 'WorkflowCc',
        component: () => import('@/views/workflow/WorkflowCc.vue'),
        meta: { title: '抄送我的', permKey: 'workflow/cc' }
      },
      {
        path: 'workflow/model',
        name: 'WorkflowModel',
        component: () => import('@/views/workflow/WorkflowModel.vue'),
        meta: { title: '模型管理', permKey: 'workflow/model' }
      },
      {
        path: 'workflow/data',
        name: 'WorkflowData',
        component: () => import('@/views/workflow/WorkflowData.vue'),
        meta: { title: '数据管理', permKey: 'workflow/data' }
      },
      {
        path: 'workflow/component',
        name: 'WorkflowComponent',
        component: () => import('@/views/workflow/WorkflowComponent.vue'),
        meta: { title: '组件管理', permKey: 'workflow/component' }
      },
      {
        path: 'workflow/stats',
        name: 'WorkflowStats',
        component: () => import('@/views/workflow/WorkflowStats.vue'),
        meta: { title: '数据统计', permKey: 'workflow/stats' }
      },
      // ---------- 品质管理 ----------
      {
        path: 'quality/main',
        name: 'QualityMain',
        redirect: '/quality/service-item'
      },
      {
        path: 'quality/service-item',
        name: 'QualityServiceItem',
        component: () => import('@/views/quality/ServiceItemManage.vue'),
        meta: { title: '服务项目' }
      },
      {
        path: 'quality/plan',
        name: 'QualityPlan',
        component: () => import('@/views/quality/PlanManage.vue'),
        meta: { title: '品质计划' }
      },
      {
        path: 'quality/rectify-rate',
        name: 'QualityRectifyRate',
        component: () => import('@/views/quality/RectifyRate.vue'),
        meta: { title: '整改合格率' }
      },
      {
        path: 'quality/contract',
        name: 'QualityContract',
        component: () => import('@/views/quality/ContractManage.vue'),
        meta: { title: '合同管理' }
      },
      {
        path: 'quality/daily-check',
        name: 'QualityDailyCheck',
        component: () => import('@/views/quality/DailyCheck.vue'),
        meta: { title: '工作日核' }
      },
      {
        path: 'quality/daily-stats',
        name: 'QualityDailyStats',
        component: () => import('@/views/quality/DailyStats.vue'),
        meta: { title: '日核统计' }
      },
      {
        path: 'quality/deduction',
        name: 'QualityDeduction',
        component: () => import('@/views/quality/DeductionList.vue'),
        meta: { title: '扣款明细表' }
      },
      {
        path: 'quality/staff-check',
        name: 'QualityStaffCheck',
        component: () => import('@/views/quality/StaffCheck.vue'),
        meta: { title: '项目成员核查' }
      },
      {
        path: 'quality/rectify',
        name: 'QualityRectify',
        component: () => import('@/views/quality/RectifyManage.vue'),
        meta: { title: '品质整改' }
      },
      {
        path: 'quality/query',
        name: 'QualityQuery',
        component: () => import('@/views/quality/QualityQuery.vue'),
        meta: { title: '品质查询' }
      },
      {
        path: 'quality/verify',
        name: 'QualityVerify',
        component: () => import('@/views/quality/VerifyManage.vue'),
        meta: { title: '品质复核' }
      },
      // ---------- 财务管理 ----------
      {
        path: 'finance/main',
        redirect: '/finance/voucher-gen'
      },
      {
        path: 'finance/center',
        redirect: '/finance/account-set'
      },
      { path: 'finance/interface', name: 'FinanceInterface', component: () => import('@/views/finance/InterfaceConfig.vue'), meta: { title: '接口参数', permKey: 'finance/interface', parentTitle: '凭证管理' } },
      { path: 'finance/account-set', name: 'FinanceAccountSet', component: () => import('@/views/finance/AccountSet.vue'), meta: { title: '账套设置', permKey: 'finance/account-set', parentTitle: '凭证管理' } },
      { path: 'finance/manage-dim', name: 'FinanceManageDim', component: () => import('@/views/finance/ManageDim.vue'), meta: { title: '管理项目', permKey: 'finance/manage-dim', parentTitle: '凭证管理' } },
      { path: 'finance/subject', name: 'FinanceSubject', component: () => import('@/views/finance/SubjectConfig.vue'), meta: { title: '科目配置', permKey: 'finance/subject', parentTitle: '凭证管理' } },
      { path: 'finance/voucher-gen', name: 'FinanceVoucherGen', component: () => import('@/views/finance/VoucherGenerate.vue'), meta: { title: '生成凭证', permKey: 'finance/voucher-gen', parentTitle: '凭证管理' } },
      { path: 'finance/invoice', name: 'FinanceInvoice', component: () => import('@/views/finance/InvoiceList.vue'), meta: { title: '数电发票', permKey: 'finance/invoice', parentTitle: '发票管理' } },
      { path: 'finance/buyer', name: 'FinanceBuyer', component: () => import('@/views/finance/BuyerList.vue'), meta: { title: '购买方信息', permKey: 'finance/buyer', parentTitle: '发票管理' } },
      { path: 'finance/preissue', name: 'FinancePreissue', component: () => import('@/views/finance/PreissueReport.vue'), meta: { title: '预开收款报表', permKey: 'finance/preissue', parentTitle: '发票管理' } },
      { path: 'finance/bank-agreement', name: 'FinanceBankAgreement', component: () => import('@/views/finance/BankAgreement.vue'), meta: { title: '银行托收协议', permKey: 'finance/bank-agreement', parentTitle: '代收代扣' } },
      { path: 'finance/bank-scheme', name: 'FinanceBankScheme', component: () => import('@/views/finance/BankScheme.vue'), meta: { title: '银行托收方案', permKey: 'finance/bank-scheme', parentTitle: '代收代扣' } },
      { path: 'finance/bank-collection', name: 'FinanceBankCollection', component: () => import('@/views/finance/BankCollection.vue'), meta: { title: '银行托收', permKey: 'finance/bank-collection', parentTitle: '代收代扣' } },
      { path: 'finance/svc-overview', name: 'FinanceSvcOverview', component: () => import('@/views/finance/SvcOverview.vue'), meta: { title: '合同概况', permKey: 'finance/svc-overview', parentTitle: '服务合同' } },
      { path: 'finance/svc-contract', name: 'FinanceSvcContract', component: () => import('@/views/finance/SvcContract.vue'), meta: { title: '收支合同', permKey: 'finance/svc-contract', parentTitle: '服务合同' } },
      { path: 'finance/svc-expired', name: 'FinanceSvcExpired', component: () => import('@/views/finance/SvcExpired.vue'), meta: { title: '过期合同', permKey: 'finance/svc-expired', parentTitle: '服务合同' } },
      { path: 'finance/company-account', name: 'FinanceCompanyAccount', component: () => import('@/views/finance/CompanyAccount.vue'), meta: { title: '银行账户', permKey: 'finance/company-account', parentTitle: '服务合同' } },
      { path: 'finance/svc-pay-plan', name: 'FinanceSvcPayPlan', component: () => import('@/views/finance/SvcPayPlan.vue'), meta: { title: '回款计划', permKey: 'finance/svc-pay-plan', parentTitle: '服务合同' } },
      { path: 'finance/svc-payment', name: 'FinanceSvcPayment', component: () => import('@/views/finance/SvcPayment.vue'), meta: { title: '付款登记审核', permKey: 'finance/svc-payment', parentTitle: '服务合同' } },
      { path: 'finance/svc-archive', name: 'FinanceSvcArchive', component: () => import('@/views/finance/SvcArchive.vue'), meta: { title: '档案管理', permKey: 'finance/svc-archive', parentTitle: '服务合同' } },
      { path: 'finance/budget-template', name: 'FinanceBudgetTemplate', component: () => import('@/views/finance/BudgetTemplate.vue'), meta: { title: '预算模板', permKey: 'finance/budget-template', parentTitle: '预算管理' } },
      { path: 'finance/budget', name: 'FinanceBudget', component: () => import('@/views/finance/BudgetList.vue'), meta: { title: '预算编制', permKey: 'finance/budget', parentTitle: '预算管理' } },
      { path: 'finance/budget-detail', name: 'FinanceBudgetDetail', component: () => import('@/views/finance/BudgetDetail.vue'), meta: { title: '预算明细', permKey: 'finance/budget-detail', parentTitle: '预算管理' } },
      { path: 'finance/budget-change', name: 'FinanceBudgetChange', component: () => import('@/views/finance/BudgetChange.vue'), meta: { title: '预算变更', permKey: 'finance/budget-change', parentTitle: '预算管理' } },
      { path: 'finance/reimburse', name: 'FinanceReimburse', component: () => import('@/views/finance/ReimburseList.vue'), meta: { title: '报销管理', permKey: 'finance/reimburse', parentTitle: '费用执行' } },
      { path: 'finance/loan', name: 'FinanceLoan', component: () => import('@/views/finance/LoanList.vue'), meta: { title: '借款管理', permKey: 'finance/loan', parentTitle: '费用执行' } },
      { path: 'finance/public-pay', name: 'FinancePublicPay', component: () => import('@/views/finance/PublicPayList.vue'), meta: { title: '对公请款', permKey: 'finance/public-pay', parentTitle: '费用执行' } },
      // ---------- 人力资源 ----------
      {
        path: 'hr/employee',
        name: 'HrEmployee',
        component: () => import('@/views/hr/EmployeeList.vue'),
        meta: { title: '员工管理', permKey: 'hr/employee', parentTitle: '人力资源' }
      },
      {
        path: 'hr/change',
        name: 'HrChange',
        component: () => import('@/views/hr/ChangeList.vue'),
        meta: { title: '变更记录', permKey: 'hr/change', parentTitle: '人力资源' }
      },
      {
        path: 'hr/resigned',
        name: 'HrResigned',
        component: () => import('@/views/hr/ResignedList.vue'),
        meta: { title: '离职列表', permKey: 'hr/resigned', parentTitle: '人力资源' }
      },
      {
        path: 'hr/visitor',
        name: 'HrVisitor',
        component: () => import('@/views/hr/VisitorList.vue'),
        meta: { title: '访客记录', permKey: 'hr/visitor', parentTitle: '人力资源' }
      },
      // ---------- 考勤管理 ----------
      {
        path: 'hr/clock',
        name: 'HrClock',
        component: () => import('@/views/hr/ClockList.vue'),
        meta: { title: '打卡明细', permKey: 'hr/clock', parentTitle: '考勤管理' }
      },
      {
        path: 'hr/daily',
        name: 'HrDaily',
        component: () => import('@/views/hr/DailyStats.vue'),
        meta: { title: '每日统计', permKey: 'hr/daily', parentTitle: '考勤管理' }
      },
      {
        path: 'hr/shift',
        name: 'HrShift',
        component: () => import('@/views/hr/ShiftList.vue'),
        meta: { title: '打卡时间表', permKey: 'hr/shift', parentTitle: '考勤管理' }
      },
      {
        path: 'hr/monthly',
        name: 'HrMonthly',
        component: () => import('@/views/hr/MonthlyList.vue'),
        meta: { title: '月度汇总', permKey: 'hr/monthly', parentTitle: '考勤管理' }
      },
      {
        path: 'hr/leave',
        name: 'HrLeave',
        component: () => import('@/views/hr/LeaveList.vue'),
        meta: { title: '请假申请', permKey: 'hr/leave', parentTitle: '考勤管理' }
      },
      {
        path: 'hr/profile',
        name: 'HrProfile',
        component: () => import('@/views/hr/ProfileSettings.vue'),
        meta: { title: '个人设置', permKey: 'hr/profile', parentTitle: '个人设置' }
      },
      {
        path: 'hr/behavior',
        name: 'HrBehavior',
        component: () => import('@/views/hr/BehaviorList.vue'),
        meta: { title: '行为分析', permKey: 'hr/behavior', parentTitle: '行为分析' }
      },
      {
        path: 'hr/report',
        name: 'HrReport',
        component: () => import('@/views/hr/HrReport.vue'),
        meta: { title: '人力报表', permKey: 'hr/report', parentTitle: '人力报表' }
      },
      {
        path: 'hr/center',
        redirect: '/hr/employee'
      },
      // ---------- AI 智能服务 ----------
      {
        path: 'ai/manage',
        name: 'AiManage',
        component: () => import('@/views/ai/AiManage.vue'),
        meta: { title: 'AI管理中心', permKey: 'ai/manage' }
      },
      {
        path: 'ai/center',
        name: 'AiCenter',
        component: () => import('@/views/ai/AiCenter.vue'),
        meta: { title: '智能客服', permKey: 'ai/center' }
      },
      {
        path: 'ai/sessions',
        name: 'AiSessionMonitor',
        component: () => import('@/views/ai/AiSessionMonitor.vue'),
        meta: { title: '会话监控', permKey: 'ai/sessions' }
      },
      {
        path: 'ai/knowledge',
        name: 'AiKnowledge',
        component: () => import('@/views/ai/AiKnowledge.vue'),
        meta: { title: '知识库管理', permKey: 'ai/knowledge' }
      },
      {
        path: 'ai/analytics',
        name: 'AiAnalytics',
        component: () => import('@/views/ai/AiAnalytics.vue'),
        meta: { title: '机器人数据分析', permKey: 'ai/analytics' }
      },
      {
        path: 'ai/robot',
        name: 'AiRobot',
        component: () => import('@/views/ai/AiRobot.vue'),
        meta: { title: '巡逻机器人', permKey: 'ai/robot' }
      },
      {
        path: 'ai/maint',
        name: 'AiMaint',
        component: () => import('@/views/ai/AiMaint.vue'),
        meta: { title: '维保预判', permKey: 'ai/maint' }
      },
      {
        path: 'ai/alert',
        name: 'AiAlert',
        component: () => import('@/views/ai/AiAlert.vue'),
        meta: { title: '告警中心', permKey: 'ai/alert' }
      },
      {
        path: 'ai/sentiment',
        name: 'AiSentiment',
        component: () => import('@/views/ai/AiSentiment.vue'),
        meta: { title: '舆情分析', permKey: 'ai/sentiment' }
      },
      {
        path: 'ai/config',
        name: 'AiConfig',
        component: () => import('@/views/ai/AiConfig.vue'),
        meta: { title: 'AI系统配置', permKey: 'ai/config' }
      },
      // ---------- 数据中台 ----------
      {
        path: 'datacenter/overview',
        name: 'DcOverview',
        component: () => import('@/views/datacenter/DcOverview.vue'),
        meta: { title: '集团总览', permKey: 'datacenter/overview' }
      },
      {
        path: 'datacenter/project',
        name: 'DcProject',
        component: () => import('@/views/datacenter/DcProject.vue'),
        meta: { title: '项目主数据', permKey: 'datacenter/project' }
      },
      {
        path: 'datacenter/customer',
        name: 'DcCustomer',
        component: () => import('@/views/datacenter/DcCustomer.vue'),
        meta: { title: '客户主数据', permKey: 'datacenter/customer' }
      },
      {
        path: 'datacenter/resource',
        name: 'DcResource',
        component: () => import('@/views/datacenter/DcResource.vue'),
        meta: { title: '资源主数据', permKey: 'datacenter/resource' }
      },
      {
        path: 'datacenter/supplier',
        name: 'DcSupplier',
        component: () => import('@/views/datacenter/DcSupplier.vue'),
        meta: { title: '供方主数据', permKey: 'datacenter/supplier' }
      },
      {
        path: 'datacenter/space',
        name: 'DcSpace',
        component: () => import('@/views/datacenter/DcSpace.vue'),
        meta: { title: '空间主数据', permKey: 'datacenter/space' }
      },
      {
        path: 'datacenter/employee',
        name: 'DcEmployee',
        component: () => import('@/views/datacenter/DcEmployee.vue'),
        meta: { title: '员工主数据', permKey: 'datacenter/employee' }
      },
      {
        path: 'datacenter/access',
        name: 'DcAccess',
        component: () => import('@/views/datacenter/DcAccess.vue'),
        meta: { title: '门禁道闸', permKey: 'datacenter/access' }
      },
      {
        path: 'datacenter/eba',
        name: 'DcEba',
        component: () => import('@/views/datacenter/DcEba.vue'),
        meta: { title: '楼宇自控', permKey: 'datacenter/eba' }
      },
      {
        path: 'datacenter/call',
        name: 'DcCall',
        component: () => import('@/views/datacenter/DcCall.vue'),
        meta: { title: '400客服对接', permKey: 'datacenter/call' }
      },
      {
        path: 'datacenter/api',
        name: 'DcApi',
        component: () => import('@/views/datacenter/DcApi.vue'),
        meta: { title: 'API管理', permKey: 'datacenter/api' }
      },
      {
        path: 'datacenter/governance',
        name: 'DcGovernance',
        component: () => import('@/views/datacenter/DcGovernance.vue'),
        meta: { title: '数据治理', permKey: 'datacenter/governance' }
      },
      {
        path: 'datacenter/permission',
        name: 'DcPermission',
        component: () => import('@/views/datacenter/DcPermission.vue'),
        meta: { title: '权限体系', permKey: 'datacenter/permission' }
      },
      {
        path: 'datacenter/center',
        name: 'DataCenter',
        component: () => import('@/views/datacenter/DataCenter.vue'),
        meta: { title: '中台管理', permKey: 'datacenter/center' }
      },
      // ---------- BI 大屏 ----------
      {
        path: 'bi/dashboard',
        name: 'BiDashboard',
        component: () => import('@/views/bi/BiDashboard.vue'),
        meta: { title: '集团驾驶舱', permKey: 'bi/dashboard' }
      },
      {
        path: 'bi/center',
        name: 'BiCenter',
        component: () => import('@/views/bi/BiCenter.vue'),
        meta: { title: '决策总览', permKey: 'bi/center' }
      },
      {
        path: 'bi/screen',
        name: 'BiScreen',
        component: () => import('@/views/bi/BiScreen.vue'),
        meta: { title: 'BI大屏', permKey: 'bi/screen' }
      },
      {
        path: 'bi/screen-config',
        name: 'BiScreenConfig',
        component: () => import('@/views/bi/BiScreenConfig.vue'),
        meta: { title: '大屏配置', permKey: 'bi/screen-config' }
      },
      {
        path: 'bi/compare',
        name: 'BiCompare',
        component: () => import('@/views/bi/BiCompare.vue'),
        meta: { title: '项目对比', permKey: 'bi/compare' }
      },
      {
        path: 'bi/warning',
        name: 'BiWarning',
        component: () => import('@/views/bi/BiWarning.vue'),
        meta: { title: '风险预警', permKey: 'bi/warning' }
      },
      {
        path: 'bi/warning-config',
        name: 'BiWarningConfig',
        component: () => import('@/views/bi/BiWarningConfig.vue'),
        meta: { title: '预警配置', permKey: 'bi/warning-config' }
      },
      {
        path: 'bi/role-board',
        name: 'BiRoleBoard',
        component: () => import('@/views/bi/BiRoleBoard.vue'),
        meta: { title: '角色看板', permKey: 'bi/role-board' }
      },
      {
        path: 'bi/report',
        name: 'BiReport',
        component: () => import('@/views/bi/BiReport.vue'),
        meta: { title: '集团报表', permKey: 'bi/report' }
      },
      // ---------- 多经运营 ----------
      {
        path: 'multibiz/main',
        name: 'MultiBizMain',
        component: () => import('@/views/multibiz/MultiBizMain.vue'),
        meta: { title: '资源运营', permKey: 'multibiz/main' }
      },
      {
        path: 'multibiz/center',
        name: 'MultiBizCenter',
        component: () => import('@/views/multibiz/MultiBizCenter.vue'),
        meta: { title: '多经中心', permKey: 'multibiz/center' }
      },
      {
        path: 'multibiz/parking',
        name: 'MultiBizParking',
        component: () => import('@/views/multibiz/MultiBizParking.vue'),
        meta: { title: '车位管理', permKey: 'multibiz/parking' }
      },
      {
        path: 'multibiz/venue',
        name: 'MultiBizVenue',
        component: () => import('@/views/multibiz/MultiBizVenue.vue'),
        meta: { title: '场地运营', permKey: 'multibiz/venue' }
      },
      {
        path: 'multibiz/ad',
        name: 'MultiBizAd',
        component: () => import('@/views/multibiz/MultiBizAd.vue'),
        meta: { title: '广告位管理', permKey: 'multibiz/ad' }
      },
      {
        path: 'multibiz/presale',
        name: 'MultiBizPresale',
        component: () => import('@/views/multibiz/MultiBizPresale.vue'),
        meta: { title: '前介案场', permKey: 'multibiz/presale' }
      },
      {
        path: 'multibiz/housekeeping',
        name: 'MultiBizHousekeeping',
        component: () => import('@/views/multibiz/MultiBizHousekeeping.vue'),
        meta: { title: '家政服务', permKey: 'multibiz/housekeeping' }
      },
      {
        path: 'multibiz/care',
        name: 'MultiBizCare',
        component: () => import('@/views/multibiz/MultiBizCare.vue'),
        meta: { title: '养老服务', permKey: 'multibiz/care' }
      },
      {
        path: 'multibiz/locker',
        name: 'MultiBizLocker',
        component: () => import('@/views/multibiz/MultiBizLocker.vue'),
        meta: { title: '快递柜', permKey: 'multibiz/locker' }
      },
      {
        path: 'multibiz/water',
        name: 'MultiBizWater',
        component: () => import('@/views/multibiz/MultiBizWater.vue'),
        meta: { title: '桶装水配送', permKey: 'multibiz/water' }
      },
      {
        path: 'multibiz/proxy',
        name: 'MultiBizProxy',
        component: () => import('@/views/multibiz/MultiBizProxy.vue'),
        meta: { title: '代缴服务', permKey: 'multibiz/proxy' }
      },
      {
        path: 'multibiz/report',
        name: 'MultiBizReport',
        component: () => import('@/views/multibiz/MultiBizReport.vue'),
        meta: { title: '综合报表', permKey: 'multibiz/report' }
      },
      // ---------- 扩展服务 ----------
      {
        path: 'utility/realtime',
        name: 'RealtimeMeters',
        component: () => import('@/views/utility/RealtimeMeters.vue'),
        meta: { title: '实时走表数', permKey: 'utility/realtime' }
      },
      {
        path: 'utility/interval',
        name: 'IntervalUsage',
        component: () => import('@/views/utility/IntervalUsage.vue'),
        meta: { title: '区间走表数', permKey: 'utility/interval' }
      },
      {
        path: 'utility/daily',
        name: 'DailyUsage',
        component: () => import('@/views/utility/DailyUsage.vue'),
        meta: { title: '区间日耗数', permKey: 'utility/daily' }
      },
      {
        path: 'utility/recharge',
        name: 'MeterRecharge',
        component: () => import('@/views/utility/MeterRecharge.vue'),
        meta: { title: '仪表充值', permKey: 'utility/recharge' }
      },
      {
        path: 'utility/park',
        name: 'ParkEnergy',
        component: () => import('@/views/utility/ParkEnergy.vue'),
        meta: { title: '园区数据信息', permKey: 'utility/park' }
      },
      {
        path: 'utility/reading-e',
        name: 'ReadingArchiveE',
        component: () => import('@/views/utility/ReadingArchive.vue'),
        meta: { title: '电表抄表记录', permKey: 'utility/reading-e', meterType: '电表' }
      },
      {
        path: 'utility/reading-w',
        name: 'ReadingArchiveW',
        component: () => import('@/views/utility/ReadingArchive.vue'),
        meta: { title: '水表抄表记录', permKey: 'utility/reading-w', meterType: '水表' }
      },
      {
        path: 'utility/finance-e',
        name: 'UtilityFinanceE',
        component: () => import('@/views/utility/UtilityFinance.vue'),
        meta: { title: '电表财务报表', permKey: 'utility/finance-e', meterType: '电表' }
      },
      {
        path: 'utility/finance-w',
        name: 'UtilityFinanceW',
        component: () => import('@/views/utility/UtilityFinance.vue'),
        meta: { title: '水表财务报表', permKey: 'utility/finance-w', meterType: '水表' }
      },
      {
        path: 'utility/recharge-h',
        name: 'RechargeHistory',
        component: () => import('@/views/utility/RechargeHistory.vue'),
        meta: { title: '历史充值记录', permKey: 'utility/recharge-h' }
      },
      {
        path: 'vas/account',
        name: 'VasAccount',
        component: () => import('@/views/vas/VasAccount.vue'),
        meta: { title: '增值服务余额', permKey: 'vas/account' }
      },
      {
        path: 'vas/product',
        name: 'VasProduct',
        component: () => import('@/views/vas/VasProduct.vue'),
        meta: { title: '增值服务商品', permKey: 'vas/product' }
      },
      {
        path: 'vas/report',
        name: 'VasReport',
        component: () => import('@/views/vas/VasReport.vue'),
        meta: { title: '增值服务报表', permKey: 'vas/report' }
      },
      {
        path: 'vas/deposit',
        name: 'VasDeposit',
        component: () => import('@/views/vas/VasDeposit.vue'),
        meta: { title: '增值服务押金', permKey: 'vas/deposit' }
      },
      {
        path: 'vas/order',
        name: 'VasOrder',
        component: () => import('@/views/vas/VasOrder.vue'),
        meta: { title: '增值服务订单', permKey: 'vas/order' }
      },
      {
        path: 'vas/verify',
        name: 'VasVerify',
        component: () => import('@/views/vas/VasVerify.vue'),
        meta: { title: '增值服务核销', permKey: 'vas/verify' }
      },
      {
        path: 'elder/main',
        name: 'ElderMain',
        component: () => import('@/views/elder/ElderMain.vue'),
        meta: { title: '养老服务', permKey: 'elder/main' }
      },
      {
        path: 'club/main',
        name: 'ClubMain',
        component: () => import('@/views/club/ClubMain.vue'),
        meta: { title: '会所管理', permKey: 'club/main' }
      },
      {
        path: 'vehicle/main',
        name: 'VehicleMain',
        component: () => import('@/views/vehicle/VehicleMain.vue'),
        meta: { title: '车辆维修', permKey: 'vehicle/main' }
      },
      {
        path: 'staff-app/main',
        name: 'StaffAppMain',
        component: () => import('@/views/staffapp/StaffAppMain.vue'),
        meta: { title: '员工APP功能配置', permKey: 'staff-app/main' }
      },
      {
        path: 'call/main',
        name: 'CallMain',
        component: () => import('@/views/call/CallMain.vue'),
        meta: { title: '呼叫中心', permKey: 'call/main' }
      },
      {
        path: 'engineering/main',
        name: 'EngineeringMain',
        component: () => import('@/views/engineering/EngineeringMain.vue'),
        meta: { title: '工程台账', permKey: 'engineering/main' }
      },
      {
        path: 'extension/main',
        name: 'ExtensionMain',
        component: () => import('@/views/extension/ExtensionMain.vue'),
        meta: { title: '扩展服务', permKey: 'extension/main' }
      }
    ]
  }
];

export default new VueRouter({
  mode: 'hash',
  routes
});
